import React from 'react'
import { Box, Typography } from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import { StarEmptyIcon, StarFullIcon, StarHalfIcon } from '../icons'

function isFloat(n) {
  return Number(n) === n && n % 1 !== 0
}

function Ratings({ align, big, label, orientation, score, starSize }) {
  const viewBox = '0 0 24 24'
  const totalStars = 5
  const isHorizontal = orientation === 'horizontal'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isHorizontal ? 'row' : 'column',
        alignItems: align,
        justifyContent: 'space-between',
      }}
    >
      {label && (
        <Typography
          component="span"
          variant={big ? 'h3' : 'body1'}
          sx={({ spacing }) => ({
            m: isHorizontal ? spacing(0, 2, 0, 0) : spacing(0, 0, 1),
          })}
        >
          {label}
          <Box component="strong" sx={{ ml: 1 }}>
            {parseFloat(score).toFixed(1)}
          </Box>
        </Typography>
      )}
      <Box
        component="span"
        sx={({ palette }) => ({
          display: 'flex',
          alignItems: 'center',
          color: palette.common.brand,
        })}
      >
        {map([...new Array(totalStars)], (arr, index) => {
          const value = index + 1
          if (isFloat(score) && value === Math.ceil(score)) {
            return (
              <StarHalfIcon
                key={index}
                width={starSize}
                height={starSize}
                viewBox={viewBox}
              />
            )
          }
          if (value <= score) {
            return (
              <StarFullIcon
                key={index}
                width={starSize}
                height={starSize}
                viewBox={viewBox}
              />
            )
          }
          return (
            <StarEmptyIcon
              key={index}
              width={starSize}
              height={starSize}
              viewBox={viewBox}
            />
          )
        })}
      </Box>
    </Box>
  )
}

Ratings.propTypes = {
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  big: PropTypes.bool,
  label: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  score: PropTypes.number,
  starSize: PropTypes.oneOf([20, 36, 48]),
}
Ratings.defaultProps = {
  align: 'center',
  big: false,
  label: null,
  orientation: 'horizontal',
  score: 0,
  starSize: 20,
}
export default Ratings
